import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class DataSharingService {
  private BATCH_STORAGE_KEY = "selected_batchNo";

  // Initialize with stored value or default to 0
  private batchNo = new BehaviorSubject<number>(this.getSavedBatchNo());
  currentBatchNo = this.batchNo.asObservable();

  constructor() {}

  changeBatchNo(batchNo: number) {
    this.batchNo.next(batchNo);
    sessionStorage.setItem(this.BATCH_STORAGE_KEY, batchNo.toString());
  }

  // Get the saved batch number from session storage
  private getSavedBatchNo(): number {
    const savedBatchNo = sessionStorage.getItem(this.BATCH_STORAGE_KEY);
    return savedBatchNo ? parseInt(savedBatchNo, 10) : 0;
  }

  clearSavedBatchSelection() {
    sessionStorage.removeItem(this.BATCH_STORAGE_KEY);
    this.batchNo.next(0);
  }
}
